import React from 'react';
import AppButton from 'components/designSystem/AppButton';

export const TestMDXButton = () => (
  <AppButton onPress={() => alert('button pressed')}>Press me!</AppButton>
);
